export default __webpack_public_path__ + "static/media/zero-percent.f68276d9.png";